import { Injectable } from '@angular/core';
import { MultipleSelects } from '../_models/multipleSelect';

@Injectable({
  providedIn: 'root'
})
export class HelperService {
  processedArray: MultipleSelects[];
  oneItem: MultipleSelects;

  constructor() { }

  populateIsChecked(sourceArray:any[], keyArray:any[])
  {
    sourceArray.forEach(x => {
      this.oneItem.detail = x;
      this.processedArray.push(this.oneItem);
    })
  }

}
